angular.module('impactx.toolbar').controller('ListFilterToggleCtrl', [
    'ListFilterService',
    'ToolbarService',
    'themeFactory',
    'TranslationService',
    ListFilterToggleController
]);

function ListFilterToggleController(ListFilterService, ToolbarService, themeFactory, TranslationService) {
    var self = this;
    self.theme = themeFactory.getTheme;
    self.translationService = TranslationService;
}